$(function() {
	var sizeToVolume = {
		'8': {"min": 12, "max": 25},
		'10': {"min": 20, "max": 45},
		'12': {"min": 30, "max": 60},
		'15': {"min": 35, "max": 100},
		'18': {"min": 50, "max": 140}
	};
	var slapsSizeToVariants = {
		'8':  [{"name": "SLAPS-M8", "params": {"B8": 185, "B7": 0.0220, "a": 14630000, "b": 0, "c": 1.463, "d": 1/50.4328}}],
		'10': [{"name": "SLAPS M10", "params": {"B8": 280, "B7": 0.0301, "a": 14630000, "b": 0, "c": 1.463, "d": 1/50.4328}}],
		'12': [{"name": "SLAPS M12", "params": {"B8": 287, "B7": 0.044, "a": 14700000, "b": 1, "c": 1.47, "d": 0.0211}},
			   {"name": "SLAPS-12",  "params": {"B8": 400, "B7": 0.042, "a": 14630000, "b": -2, "c": 1.463, "d": 1/50.4328}}],
		'15': [{"name": "SLAPS-15",  "params": {"B8": 765, "B7": 0.0764, "a": 14630000, "b": -2, "c": 1.463, "d": 1/50.4328}}],
		'18': [{"name": "SLAPS-18",  "params": {"B8": 377, "B7": 0.1083, "a": 14630000, "b": -2, "c": 1.463, "d": 1/50.4328}}],
	};
	var maxWeight = 400;

	var inputs = {};

	function computeMinSlapsQty(inputs) {
		var wsize = inputs['woofersize'];
		var ssize = inputs['slapssize'];
		if (!wsize || !ssize)
			return 0;
		var qty = Math.ceil(((wsize/2)*(wsize/2)*Math.PI)/((ssize/2)*(ssize/2)*Math.PI));
		return qty;
	}

	function computeWeight(inputs, freq) {
		var variant = inputs["variant"];
		var slapsQty = inputs["slapsQty"];
		if (!variant || !slapsQty)
			return 0;
		var params = variant["params"];
		var B6 = inputs["volume"]/28.3168;
		var B7 = params["B7"];
		var B11 = Math.sqrt(Math.pow(2*(Math.sqrt(B7/Math.PI))*39.37, 2)*slapsQty)
		//console.log(params, inputs, freq, B6, B7, B11);
		//(14700000*(B11/2)^2/((B5+1)^2*B6*1728)-1.47*B11/2)*(3.14159*(B11/2)^2)*0.0211
		var mass = (params["a"]*Math.pow(B11/2, 2)/(Math.pow(freq+params["b"], 2)*B6*1728)-params["c"]*B11/2)*(Math.PI*Math.pow(B11/2, 2))*params["d"];
		var massPerUnit = mass/slapsQty;
		var additionalMass = massPerUnit - params["B8"];
		return additionalMass;
	}

	function computeFrequency(inputs, additionalMass) {
		var variant = inputs["variant"];
		var slapsQty = inputs["slapsQty"];
		if (!variant || !slapsQty)
			return 0;
		var params = variant["params"];
		var B6 = inputs["volume"]/28.3168;
		var B7 = params["B7"];
		var B11 = Math.sqrt(Math.pow(2*(Math.sqrt(B7/Math.PI))*39.37, 2)*slapsQty)
		var massPerUnit = additionalMass + params["B8"];
		var mass = massPerUnit*slapsQty;
		var freq = Math.sqrt((params["a"]*Math.pow(B11/2, 2))/((mass/((Math.PI*Math.pow(B11/2, 2))*params["d"])+params["c"]*B11/2)*B6*1728))-params["b"];
		//console.log(additionalMass, massPerUnit, mass, freq);
		return freq;
	}

	function recompute() {
		var minSlapsQty = computeMinSlapsQty(inputs);
		$('#slapsQtyTxt').text(minSlapsQty.toString());
		$('#slapsQty').prop('min', minSlapsQty);
		var slapsQty = $('#slapsQty').val();
		if (!slapsQty || slapsQty < minSlapsQty)
			$('#slapsQty').val(minSlapsQty.toString());
		inputs["slapsQty"] = parseInt($('#slapsQty').val());
		var weight = computeWeight(inputs, inputs["freq"]);
		$('#weightTxt').text(Math.round(weight).toString());
		if (weight >= 0) {
			$('#addWeightTxt').show();
			$('#reduceCabinetTxt').hide();
		} else {
			$('#addWeightTxt').hide();
			$('#reduceCabinetTxt').show();
		}
		var resFreq = computeFrequency(inputs, 0);
		$('#resTuningFreqTxt').text(Math.round(resFreq));
		var minFreq = Math.ceil(computeFrequency(inputs, maxWeight));
		var maxFreq = Math.floor(resFreq);
		$('#minFreqTxt').text(minFreq.toString());
		$('#maxFreqTxt').text(maxFreq.toString());
		$('#tuningFreq').prop('min', minFreq).prop('max', maxFreq);
	}

	$('input[name=woofersize]').change(function() {
		var size = $(this).val();
		inputs['woofersize'] = parseInt(size);
		recompute();
		var volumeInterval = sizeToVolume[size];
		var min = volumeInterval['min'];
		var max = volumeInterval['max'];
		$('#volumeRangeTxt').text(min + ' - ' + max);
		$('#volumeMinTxt').text(min.toString());
		$('#volumeMaxTxt').text(max.toString());
		var avg = (max+min)/2;
		$('#volumeSlider').prop('min', min).prop('max', max).val(avg.toString());
		inputs["volume"] = avg;
		$('#volumeTxt').text(avg.toString());
		$('#typeContainer').show();
	});
	$('input[name=typeConfirm]').change(function() {
		var conf = $(this).val();
		if (conf == 'yes') {
			$('#resFreqContainer').show();
		} else {
			alert('You need a speaker of type "long throw"/"long stroke"');
		}
	});
	$('input[name=resFreqConfirm]').change(function() {
		var conf = $(this).val();
		if (conf == 'yes') {
			$('#slapsSizeContainer').show();
		} else {
			alert('You need a speaker with a resonance frequency of less than 30 Hz');
		}
	});
	$('input[name=slapssize]').change(function() {
		var size = $(this).val();
		inputs['slapssize'] = parseInt(size);
		recompute();
		var variantChooser = $('#variantChooser');
		variantChooser.empty();
		var variants = slapsSizeToVariants[size];
		$(variants).each(function() {
			var variant = this;
			var varElem = $('<label class="btn btn-default"><input type="radio" name="slapsvariant" value="SLAPS-m 12" autocomplete="off"> <span class="variantName">SLAPS-m 12</span></label>');
			varElem.find('.variantName').text(this["name"]);
			varElem.find('input[name=slapsvariant]').val(this["name"]).change(function() {
				inputs["variant"] = variant;
				recompute();
				$('#volumeContainer').show();
			});
			variantChooser.append(varElem);
		});
		$('#slapsVariantContainer').show();
	});
	$('#volumeSlider').change(function() {
		var size = $(this).val();
		inputs["volume"] = parseFloat(size);
		$('#volumeTxt').text(size);
		recompute();
	});
	$('#slapsQty').change(function() {
		var qty = parseInt($(this).val());
		inputs["slapsQty"] = qty;
		recompute();
	});
	$('#tuningFreq').change(function() {
		var freq = $(this).val();
		inputs["freq"] = parseFloat(freq);
		$('#tuningFreqTxt').text(freq.toString());
		recompute();
	}).change();
});
